module.exports = __webpack_public_path__ + "static/media/refunds.c98eebc5.svg";